import request from "root/js/request";

export const getProductCardFunnelWidgets = async ({
  cabinet_id,
  cabinet_id__in,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  extra_fields,
  source,
  source__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/sales_pipeline_widgets/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      extra_fields,
      source,
      source__in,
      ...rest,
    },
  });
  return response.data;
};
